import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const BlueprintStatusLabel = () => {
  const { t } = useTranslation();

  return (
    <Typography
      data-testid="blueprint-status-label"
      variant="subtitle3"
      sx={{
        borderRadius: '4px',
        display: 'flex',
        px: '10px',
        py: '4px',
        gap: '10px',
        backgroundColor: (theme) => theme.palette.badge['hydro-blue'],
        color: (theme) => theme.palette.white,
      }}
    >
      {t('entities:blueprint.nameSingular')}
    </Typography>
  );
};
